import axios from 'axios';
import router from '../../src/router';
//import { Toast } from 'vant'
//import Vant from 'vant';

axios.defaults.timeout = 50000;
axios.defaults.baseURL = '/api';

//http request 拦截器
axios.interceptors.request.use(
	config => {
		let token = window.localStorage.getItem('tokenApp');
		if(!token) {
			token = ''
		}
		//todo
		//  config.headers = {
		//    'Content-Type':'application/x-www-form-urlencoded',
		//    'token':token,
		//    
		//  }
		//console.log(config,'config------')
		return config;
	},
	error => {
		return Promise.reject(err);
	}
);

//http response 拦截器
axios.interceptors.response.use(
	response => {
		//  	console.log(response,'拦截器---31')
		if(response.data.code == 401) {
			localStorage.clear();
			router.replace({
				path: "/",
				querry: {
					redirect: router.currentRoute.fullPath
				} //登录成功后跳入浏览的当前页面
			})
		} else if(response.data.code == '-1') {
			alert(response.data.msg)
			//  	console.log(this)
		}
		return response;
	},
	error => {
		//	console.log(response,'拦截器---40')
		return Promise.reject(error)
	}
)

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function fetch(url, params) {
	return new Promise((resolve, reject) => {
		axios.get(url, {
				params: params
			})
			.then(response => {
				//  	Toast('提示内容');
				resolve(response.data);
				//console.log(response,'response-----60')
			})
			.catch(err => {
				reject(err)
				//    console.log(err,'err-----64')
			})
	})
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data) {
	return new Promise((resolve, reject) => {
		//console.log(data)
		axios.post(url, data)
			.then(response => {
				//        	ifCode(response.data.code)
				resolve(response.data);
			}, err => {
				reject(err)
				//   			 	console.log(err,'err-----87')
			})
	})
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data) {
	return new Promise((resolve, reject) => {
		axios.patch(url, data)
			.then(response => {
				resolve(response.data);
			}, err => {
				reject(err)
			})
	})
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data) {
	return new Promise((resolve, reject) => {
		axios.put(url, data)
			.then(response => {
				resolve(response.data);
			}, err => {
				reject(err)
			})
	})
}

function ifCode(code, url) {
	switch(code) {
		case '200':
			console.log('200')
			break;
		case '-1':
			//      			CDK.info(msg);
			break;
		case '204':
			//      			CDK.info(msg);
			break;
		case '205':
			//      			CDK.info(msg);
			break;
		case '401':
			/*CDK.cfm(res=>{
				if(window.location.href.indexOf('index.html')!=-1){
					window.location.href='login.html'
				}else{
					window.parent.location.href='../login.html'
				}
			},err=>{
				if(window.location.href.indexOf('index.html')!=-1){
					window.location.href='login.html'
				}else{
					window.parent.location.href='../login.html'
				}
			},'登录过期，请重新登录！');*/
			break;
		case '402':
			//      			CDK.info('权限不足请联系管理员')
			break;
		case code.indexOf('5') == 0:
			//      			window.parent.location.href='../err404.html'
			break;
		case '601':
			//      			CDK.info(msg)
			break;
		case '602':
			//      			CDK.info(msg)
			break;
		case '603':
			//      			CDK.info(msg)/
			break;
		case '604':
			//      			CDK.info(msg)
			break;
		default:
			//      			CDK.info(msg)/
	}
}


//////////////////
// WEBPACK FOOTER
// ./static/js/http.js
// module id = null
// module chunks = 